module.exports = __webpack_public_path__ + "static/media/walk-in-video-visit.492d8ba8.svg";